module.exports = "data:image/gif;base64,R0lGODlhBgAGAIAAAO1VFP///yH5BAEAAAEALAAAAAAGAAYAAAIKTABmuHno2FMzFAA7"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_cg.gif
// module id = IPw9
// module chunks = 1